import { AbstractFilter } from "../types/AbstractFilter"

export class BoolFilter implements AbstractFilter {
    filter: { must: any[]; should: any[] }

    constructor() {
        this.filter = {
            must: [],
            should: []
        }
    }

    /**
     * List of filters that are combined by this bool filter using a logical AND.
     * @param {Filter} f the filter to be added
     * @return this
     */
    must(f: any): this {
        if (f instanceof BoolFilter) {
            if (f.filter.should.length === 0) {
                this.filter.must = this.filter.must.concat(f.filter.must)
                return this
            }
        }
        this.filter.must.push(f)
        return this
    }

    /**
     * List of filters that are combined by this bool filter using a logical OR.
     * @param {Filter} f the filter to be added
     * @return this
     */
    should(f: any): this {
        if (f instanceof BoolFilter) {
            if (f.filter.must.length === 0) {
                this.filter.should = this.filter.should.concat(f.filter.should)
                return this
            }
        }
        this.filter.should.push(f)
        return this
    }

    build(): any {
        const _must =
            this.filter.must.length === 0
                ? null
                : this.filter.must.map((m) => m.build())
        const _should =
            this.filter.should.length === 0
                ? null
                : this.filter.should.map((m) => m.build())

        return {
            boolFilter: {
                must: _must,
                should: _should
            }
        }
    }
}
